<div #googleMap class="google-map"></div>